import { api } from '@/lib/api';
import type { Role } from '@/lib/auth/types';

export interface Account {
  userId: string;
  email: string;
  displayName: string;
  role: Role;
  active: boolean;
  /** Whether they have signed in at least once, which links the directory identity. */
  linked: boolean;
}

export interface AccessEvent {
  occurredAt: string;
  actor: string;
  subject: string;
  action: string;
  detail: string;
}

export const people = {
  all: () => api.get<Account[]>('/api/users'),
  events: () => api.get<AccessEvent[]>('/api/users/events'),
  provision: (email: string, displayName: string, role: Role) =>
    api.post<Account>('/api/users', { email, displayName, role }),
  changeRole: (userId: string, role: Role) =>
    api.post<Account>(`/api/users/${userId}/role`, { role }),
  deactivate: (userId: string, reason: string) =>
    api.post<Account>(`/api/users/${userId}/deactivate`, { reason }),
  reactivate: (userId: string) => api.post<Account>(`/api/users/${userId}/reactivate`),
};
